{
  "hello": "你好 寶幣",
  "nav": {
    "orderTab": {
      "fastTrack": "極速交易"
    }
  }
}
